module.exports = __webpack_public_path__ + "img/30.38f9990c.png";